export const materialProductionType = [
    'Bahan Berbahaya dan Beracun',
    'Non Bahan Berbahaya dan Beracun'
]